import type { Option } from '@openx/types/options';
import keyBy from 'lodash/keyBy';
import { useMemo } from 'react';
import { useOptionsByPathQuery } from '../../../hooks/useOptionsByPathQuery';

export const useDemandPartnerOptionsFetch = (skip?: boolean) => {
  const { data, error, loading } = useOptionsByPathQuery({
    fetchPolicy: 'network-only',
    skip,
    variables: {
      path: 'deal.deal_participants.demand_partner',
    },
  });

  const { list, mapById } = useMemo(() => {
    const list = data?.optionsByPath.reduce<Option[]>((acc, option) => {
      if (option) {
        acc.push({ id: option.id, name: option.name });
      }

      return acc;
    }, []);

    return {
      list: list ?? [],
      mapById: keyBy(list, 'id'),
    };
  }, [data]);

  return {
    isError: !!error,
    isLoading: loading,
    list,
    mapById,
  };
};
